import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import * as S from './styles';

// Notes are legacy plain text (\n line breaks) or Tiptap HTML. Sanitize on the client because the
// API returns the stored value as-is.
const HTML_TAG = /<\/?[a-z][^>]*>/i;

export default function RichText({ html }) {
  if (!html) {
    return null;
  }
  if (!HTML_TAG.test(html)) {
    return <S.Content $plain>{html}</S.Content>;
  }
  return <S.Content dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }} />;
}

RichText.propTypes = {
  html: PropTypes.string,
};

RichText.defaultProps = {
  html: null,
};
